export default __webpack_public_path__ + "static/media/community.e5cf7750.png";